/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ItemsModule
 */

import { AviPermissionResource } from 'generated-types';
import { ControllerSite } from 'object-types';
import { ObjectTypeItem } from 'ajs/modules/data-model/factories/object-type-item.factory';

/**
 * @description ControllerSite Item.
 * @author alextsg
 */
export class ControllerSiteItem extends ObjectTypeItem {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: ControllerSite,
            objectName: 'controllersite',
            permissionName: AviPermissionResource.PERMISSION_CONTROLLERSITE,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Return address of the controller site.
     */
    public getAddress(): string {
        return this.config.address;
    }
}
